import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundNumber'
})
export class RoundNumberPipe implements PipeTransform
{

  public transform(value: number): string
  {
    if (value < 1000)
    {
      return value.toString();
    }
    else if (value >= 1000 && value < 1000000)
    {
      return (Math.round((value / 1000) * 100) / 100) + 'K';
    }
    else
    {
      return (Math.round((value / 1000000) * 100) / 100) + 'M';
    }
  }

}
